export const ROUTE_NAMES = {
  APPLE_MERCHANT_ID:
    "/.well-known/apple-developer-merchantid-domain-association",
  LANDING_ERROR: "/",
  LANDING: "/:name/:id",
  BOOKING: "/booking/:name/:id",
  BOOKING_PAYMENTS: "/select-payments/:name/:id",
  CARD_PAYMENT: "/card-payment",
  IDEAL_PAYMENT: "/ideal-payment",
  SOCIAL_PAYMENT: "/social-payment",
  PAYMENT_CHECK: "/payment-check",
  PAYMENT_COMPLETE: "/payment-complete",
  TIKKIE_PAYMENT: "/tikkie-payment",
  TIKKIE_PAY_CHECK: "/tikkie-pay-check/:id",
  ORDER_CONFIRMATION: "/order-confirmation/:eventName/:refId/:bookingId",
  // MANAGE_BOOKING: "/managebooking/event/:id",
  MANAGE_BOOKING: "/manage-booking/:id",
  SCAN_TICKET: "/scan-ticket/:id",
  GET_TICKET: "/get-ticket/:ticketToken",
  // On-site express sale reached by scanning a printed QR code. The QR encodes only the
  // product, never an event, so printed codes stay valid forever.
  ONSITE_SALE: "/onsite/:productId",
};
